import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LoginDetails } from '../models/settings/login-details.model';
import { AppConfigService } from './app-config.service';

@Injectable({
  providedIn: 'root'
})
export class ContactService {

  constructor(
    private appConfigService: AppConfigService,
    private http: HttpClient) { }

  public getContactUsDetails(): Observable<LoginDetails> {
    return this.http.get<LoginDetails>(`${this.appConfigService.getConfig().apiUrl}contactus`);
  }

  public postContactRequest(formValues: any): Observable<any> {
    return this.http.post(`${this.appConfigService.getConfig().apiUrl}contactus`, formValues);
  }
}
